var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"legal"}},[_c('div',{staticClass:"inner",domProps:{"innerHTML":_vm._s(_vm.ppDetail[_vm.localeCode])}})])}
var staticRenderFns = []

export { render, staticRenderFns }